import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import HotSection from './components/HotSection';
import NewUpdates from './components/NewUpdates';
import FeaturedSection from './components/FeaturedSection';
import TopicSection from './components/TopicSection';
import FaqSection from './components/FaqSection';

const faqs = [
  {
    q: '虫虫漫画怎么按分类找漫画？',
    a: '打开首页顶部的「题材分类速览」，或直接进入国漫频道与日漫频道，即可按玄幻、武侠、都市、科幻等题材筛选，快速找到你感兴趣的作品。',
  },
  {
    q: '国漫和日漫分别怎么浏览？',
    a: '顶部导航提供「国漫」与「日漫」两个独立频道，每个频道都支持按题材筛选和按人气、评分、更新时间排序，方便你一站式逛完对应分类。',
  },
  {
    q: '为什么有的漫画显示「连载中」，有的显示「已完结」？',
    a: '连载中的作品会持续更新最新章节，我们会在「今日新更」板块展示最新进度；已完结的作品则收录全部章节，可以放心追到底。',
  },
];

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '虫虫漫画',
      url: 'https://oiutc07.cn',
      logo: 'https://oiutc07.cn/logo.png',
      contactPoint: { '@type': 'ContactPoint', email: 'support@chongchong-manga.com', contactType: 'customer service' },
    },
    {
      '@type': 'WebSite',
      name: '虫虫漫画网',
      url: 'https://oiutc07.cn',
      potentialAction: {
        '@type': 'SearchAction',
        target: { '@type': 'EntryPoint', urlTemplate: 'https://oiutc07.cn/guoman?q={search_term_string}' },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <HotSection />
        <NewUpdates />
        <FeaturedSection />
        <TopicSection />
        <FaqSection />

        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-accent-500" aria-hidden="true"></div>
          <div className="relative mx-auto flex max-w-7xl flex-col items-center gap-6 px-4 py-14 text-center text-background-50 md:py-16">
            <h2 className="font-heading text-2xl md:text-4xl">找不到想看的？告诉我们</h2>
            <p className="max-w-xl text-sm md:text-base text-background-50/90">
              虫虫漫画持续收录国漫与日漫作品。把想看的题材或作品告诉我们，我们会优先补充相关分类内容。
            </p>
            <a
              href="/about"
              className="inline-flex items-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm font-medium text-primary-600 whitespace-nowrap hover:bg-background-100 transition-colors"
            >
              联系我们 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}